import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/compound/buildings";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/compound/dropdown/Building?status=1";
const apiToggleStatus = API_BASE_URL_ENV() + "/admin/compound/toggle-activation/Building/";
const apiCheckBuildingStatus = API_BASE_URL_ENV() + "/admin/compound/check-building-existence";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
   
    getDropDown=(id)=>{
        if(id){
            return  http.get(`${apiDropDownEndpoint}&compound_ids=${id}`) 
        }else{
            return  http.get(apiDropDownEndpoint) 

        }
    }
    toggleStatus=(id)=>{
        return http.get(`${apiToggleStatus}${id}`)
    }
    checkBuilding=(data)=>{
        return http.post(apiCheckBuildingStatus, data)
    }
}